module.exports = __webpack_public_path__ + "img/cz-partners-finex.a891fffb.png";